import { render, staticRenderFns } from "./DeletedVehicle.vue?vue&type=template&id=5ca1f15e&"
import script from "./DeletedVehicle.vue?vue&type=script&lang=js&"
export * from "./DeletedVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports